var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"app-divider"},[_c('v-col',[_c('v-divider',_vm._b({},'v-divider',_vm.$attrs,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }